import claims from './claims';

export default {
  ...claims,
  'insurance': 'Seguro',
  'insuranceData': 'Datos de seguros',
};